export const GET_MESSAGE_ROOM_INDEX = 'GET_MESSAGE_ROOM_INDEX'
export const GET_MESSAGE_ROOM_INDEX_RESULT = 'GET_MESSAGE_ROOM_INDEX_RESULT'
export const GET_MESSAGE_ROOM_RESET = 'GET_MESSAGE_ROOM_RESET'
export const GET_MESSAGES = 'GET_MESSAGES'
export const GET_MESSAGES_RESULT = 'GET_MESSAGES_RESULT'
export const GET_MESSAGES_RESET = 'GET_MESSAGES_RESET'



// WEBPACK FOOTER //
// ./src/constants/User/Messages.js